var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"step-card"},[_c('p',{staticClass:"step"},[_vm._v("STEP "),_c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.idx + 1))])]),_vm._v(" "),_c('div',{staticClass:"step-card-img-wrapper"},[_c('img',{staticClass:"step-card-img",attrs:{"src":_vm.img,"alt":_vm.description}})]),_vm._v(" "),_c('p',{staticClass:"step-card-description",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755ee2d5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LP/atoms/StepCard.vue
// module id = null
// module chunks = 